export const API_CONFIG = {
  BASE_URL: (
    import.meta.env.VITE_API_URL ||
    (import.meta.env.PROD ? 'https://www.bricolat.co.ma/api/v1' : 'http://localhost:8080/api/v1')
  ).replace(/\/+$/, '') + '/',
  TIMEOUT: 30000,

  // Endpoints (without leading slash - BASE_URL already includes /api/v1)
  ENDPOINTS: {
    // Auth
    AUTH: {
      BASE: 'auth',
      REGISTER: 'auth/register',
      LOGIN: 'auth/login',
      REFRESH: 'auth/refresh',
      LOGOUT: 'auth/logout',
      GOOGLE_CHALLENGE: 'auth/google/challenge',
      GOOGLE: 'auth/google',
      GOOGLE_REGISTRATION_START: 'auth/google/registration/start',
      GOOGLE_REGISTRATION_COMPLETE: 'auth/google/registration/complete',
    },

    // Users
    USERS: {
      ME: 'users/me',
      BY_ID: (id: string) => `users/${id}`,
      UPDATE: 'users/me',
    },

    // Categories
    CATEGORIES: {
      LIST: 'categories',
      BY_ID: (id: string) => `categories/${id}`,
    },

    // Providers
    PROVIDERS: {
      CREATE: 'providers',
      MY_PROFILE: 'providers/me',
      UPDATE: 'providers/me',  // PUT for updates
      BY_ID: (id: string) => `providers/${id}`,
      SEARCH: 'providers/search',
      SUGGEST: 'providers/suggest',
      ACTIVATE: 'providers/activate',
      PORTFOLIO_ADD: 'providers/me/portfolio',
      PORTFOLIO_REMOVE: (itemId: string) => `providers/me/portfolio/${itemId}`,
    },

    // Jobs
    JOBS: {
      LIST: 'jobs',
      CREATE: 'jobs',
      BY_ID: (id: string) => `jobs/${id}`,
      UPDATE: (id: string) => `jobs/${id}`,
      DELETE: (id: string) => `jobs/${id}`,
      PUBLISH: (id: string) => `jobs/${id}/publish`,
      MY_JOBS: 'jobs/my-jobs',
      NEARBY: 'jobs/nearby',
      SEARCH: 'jobs/search',
    },

    // Quotes
    QUOTES: {
      CREATE: 'quotes', // Legacy, to be removed/refactored
      CREATE_BY_JOB: (jobId: string) => `jobs/${jobId}/quotes`,
      BY_ID: (id: string) => `quotes/${id}`,
      UPDATE: (id: string) => `quotes/${id}`,
      ACCEPT: (id: string) => `quotes/${id}/accept`,
      REJECT: (id: string) => `quotes/${id}/reject`,
      WITHDRAW: (id: string) => `quotes/${id}/withdraw`,
      BY_JOB: (jobId: string) => `jobs/${jobId}/quotes`,
      MY_QUOTES: 'quotes/my-quotes',
    },

    // Conversations
    CONVERSATIONS: {
      LIST: 'conversations',
      BY_ID: (id: string) => `conversations/${id}`,
      MESSAGES: (id: string) => `conversations/${id}/messages`,
      SEND_MESSAGE: 'messages',
      MARK_READ: (id: string) => `conversations/${id}/mark-read`,
    },

    // Reviews
    REVIEWS: {
      CREATE: 'reviews',
      BY_PROVIDER: (providerId: string) => `reviews/provider/${providerId}`,
      BY_JOB: (jobId: string) => `reviews/job/${jobId}`,
    },

    // Images
    IMAGES: {
      UPLOAD: 'images/upload',
    },
  },
} as const;

